import {fetchShopifyCollectionProducts, renderProductCard} from './helpers';

class ByoHamper extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.animateAddToCart = this.dataset.addToCartAnimation === 'true';
    this.hamperTotalPrice = 0;

    this.hamperButtons = this.querySelectorAll('.byo-hamper__hamper');
    this.productButtons = this.querySelectorAll('.byo-hamper__collection');
    this.subCollectionButtons = this.querySelectorAll('.byo-hamper__sub-collection');
    this.hamperScrollTopElement = this.querySelector('#hamper-collection-scroll');
    this.hamperVariantSelects = this.querySelectorAll('.hamper-variant-picker__select');
    this.hamperVariantSelects.forEach(select => select.addEventListener('change', this.handleVariantSelectChange.bind(this)));
    this.hamperButtons.forEach(el => el.addEventListener('click', this.handleHamperClick.bind(this)));
    this.productButtons.forEach(el => el.addEventListener('click', this.handleHamperCollectionClick.bind(this)));
    this.subCollectionButtons.forEach(el => el.addEventListener('click', this.handleGetProducts.bind(this)));
    this.loader = this.querySelector('.byo-hamper__products .loader');
    this.productGrid = this.querySelector('.byo-hamper__products .products');
    this.menuId = self.crypto.randomUUID().split('-')[0];
    this.addToCartButton = this.querySelector('.add-to-cart-button');
    this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    this.menuTotalProductsElement = this.querySelector('.byo-hamper__total-products');
    this.menuTotalPriceElement = this.querySelector('.byo-hamper__total-price');
    this.dialog = this.querySelector('dialog');
    this.collectionScrollLeft = this.querySelector('.collection-scroll.left');
    this.collectionScrollRight = this.querySelector('.collection-scroll.right');
    this.collectionScrollLeft.addEventListener('click', this.handleCollectionScrollLeft.bind(this));
    this.collectionScrollRight.addEventListener('click', this.handleCollectionScrollRight.bind(this));
    this.subScrollLeft = this.querySelector('.sub-scroll.left');
    this.subScrollRight = this.querySelector('.sub-scroll.right');
    this.subScrollLeft.addEventListener('click', this.handleSubScrollLeft.bind(this));
    this.subScrollRight.addEventListener('click', this.handleSubScrollRight.bind(this));

    this.loadSelectedProductsFromStorage();
    this.setupCollectionScrollButtons();
    this.selectFirstCollection();

  }

  selectFirstCollection(){
    this.hamperScrollTopElement.dataset.firstLoad = 'true';
    document.querySelector('.byo-hamper__collection').click();
  }

  setupCollectionScrollButtons() {
    const container = this.querySelector('.hamper-collections .wrapper .container');
    const wrapperRect = this.querySelector('.hamper-collections .wrapper').getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const containerWidth = container.scrollWidth;
    if(containerRect.left + containerWidth > wrapperRect.right) {
      this.collectionScrollRight.classList.remove('hidden');
    }
    container.addEventListener('scrollend', this.handleContainerScroll.bind(this));
  }

  handleContainerScroll() {
    const wrapperRect = this.querySelector('.hamper-collections .wrapper').getBoundingClientRect();
    const container = this.querySelector('.hamper-collections .wrapper .container');
    const firstChild = container.firstElementChild;
    const lastChild = container.lastElementChild;
    const firstChildRect = firstChild.getBoundingClientRect();
    const lastChildRect = lastChild.getBoundingClientRect();
    if(lastChildRect.right <= wrapperRect.right) {
      this.collectionScrollRight.classList.add('hidden');
    }else{
      this.collectionScrollRight.classList.remove('hidden');
    }
    if(firstChildRect.left >= wrapperRect.left) {
      this.collectionScrollLeft.classList.add('hidden');
    }else{
      this.collectionScrollLeft.classList.remove('hidden');
    }
  }

  handleCollectionScrollLeft() {
    const activeCollection = this.querySelector('.hamper-collections .wrapper .container');
    if(activeCollection) {
      activeCollection.scrollBy({ left: -10 });
      this.collectionScrollRight.classList.remove('hidden');
    }
  }

  handleCollectionScrollRight() {
    const activeCollection = this.querySelector('.hamper-collections .wrapper .container');
    if(activeCollection) {
      activeCollection.scrollBy({ left: 10 });
      this.collectionScrollLeft.classList.remove('hidden');
    }
  }

  setupSubCollectionScrollButtons() {
    const wrapperRect = this.querySelector('.hamper-sub-collections').getBoundingClientRect();
    const container = this.querySelector('.hamper-sub-collection.active');
    const containerRect = container.getBoundingClientRect();
    const containerWidth = container.scrollWidth;
    if(containerRect.left + containerWidth > wrapperRect.right) {
      this.subScrollRight.classList.remove('hidden');
    }else {
      this.subScrollLeft.classList.add('hidden');
      this.subScrollRight.classList.add('hidden');
    }
    container.addEventListener('scrollend', this.handleSubContainerScroll.bind(this));
  }

  handleSubContainerScroll() {
    const wrapperRect = this.querySelector('.hamper-sub-collections').getBoundingClientRect();
    const container = this.querySelector('.hamper-sub-collection.active');
    const firstChild = container.firstElementChild;
    const lastChild = container.lastElementChild;
    const firstChildRect = firstChild.getBoundingClientRect();
    const lastChildRect = lastChild.getBoundingClientRect();
    if(lastChildRect.right <= wrapperRect.right) {
      this.subScrollRight.classList.add('hidden');
    }else{
      this.subScrollRight.classList.remove('hidden');
    }
    if(firstChildRect.left >= wrapperRect.left) {
      this.subScrollLeft.classList.add('hidden');
    }else{
      this.subScrollLeft.classList.remove('hidden');
    }
  }

  handleSubScrollLeft() {
    const activeSubCollection = this.querySelector('.hamper-sub-collection.active');
    if(activeSubCollection) {
      activeSubCollection.scrollBy({ left: -10 });
    }
  }

  handleSubScrollRight() {
    const activeSubCollection = this.querySelector('.hamper-sub-collection.active');
    if(activeSubCollection) {
      activeSubCollection.scrollBy({ left: 10 });
    }
  }

  #animateFlyToDrawer(source, change) {
    const drawer = document.querySelector('.byo-hamper__summary');
    // find the image closest to the input - try hampers first
    let image = source.closest('.hampers-grid--hamper')?.querySelector('img');
    if(!image){
      //try product card
      image = source.closest('.product-card')?.querySelector('img');
    }

    if (!drawer || !source || !image) return;

    const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

    flyToCartElement.style.setProperty('background-image', `url(${image.src})`);
    if(change === 1) {
      flyToCartElement.source = source;
      flyToCartElement.destination = drawer;
    }else{
      flyToCartElement.source = drawer;
      flyToCartElement.destination = source;
    }

    document.body.appendChild(flyToCartElement);
  }

  handleVariantSelectChange(evt) {
    const productId = evt.target.dataset.connectedProductId;
    const selectedVariant = evt.target.options[evt.target.selectedIndex];
    const selectedHamperPrice = parseFloat(selectedVariant.dataset.price).toFixed(2);
    document.getElementById(`hamper-price-${productId}`).innerHTML = selectedHamperPrice;
    const button = this.querySelector(`.byo-hamper__hamper[data-product-id="${productId}"]`);
    if (button && button.classList.contains('button-primary')) {
      button.click();
    }
  }

  handleHamperClick(event){
    this.hamperButtons.forEach(el => {
      el.classList.remove('button-primary');
      el.classList.add('button-secondary');
      el.innerText = 'Select';
    });
    event.target.classList.remove('button-secondary');
    event.target.classList.add('button-primary');
    event.target.innerText = 'Selected';
    const productId = event.target.dataset.productId;
    const selectedHamperSelect = this.querySelector(`.hamper-variant-picker__select[data-connected-product-id="${event.target.dataset.productId}"]`);
    const selectedVariant = selectedHamperSelect.options[selectedHamperSelect.selectedIndex];
    const selectedHamperVariantId = selectedVariant.dataset.variantId;
    const selectedHamperPrice = parseFloat(selectedVariant.dataset.price);
    const existingHamper = this.selectedProducts.find(item => item.properties.__type === 'hamper');
    let newProducts;
    if (existingHamper) {
      if (existingHamper.id === parseInt(selectedHamperVariantId)) {
        return;
      } else {
        newProducts = this.selectedProducts.filter(item => item.properties.__type !== 'hamper');
        newProducts = [...newProducts, {
          id: parseInt(selectedHamperVariantId),
          quantity: 1,
          properties: {
            __type: 'hamper',
            __price: selectedHamperPrice,
            __productId: productId,
            __hamper: this.menuId
          }
        }];
        this.selectedProducts = newProducts;
      }
    } else {
      newProducts = [...this.selectedProducts, {
        id: parseInt(selectedHamperVariantId),
        quantity: 1,
        properties: {
          __type: 'hamper',
          __price: selectedHamperPrice,
          __productId: event.target.dataset.productId,
          __hamper: this.menuId
        }
      }];
      this.selectedProducts = newProducts;
    }
    if(this.animateAddToCart) {
      this.#animateFlyToDrawer(event.target, 1);
    }
    this.updateHamperQuantity();
  }

  updateHamperQuantity(){
    this.menuTotalProductsElement.innerText = this.selectedProducts.reduce((sum, item) => sum + item.quantity, 0);
  }

  updateHamperTotalPrice() {
    // Calculate hamperTotalPrice from selectedProducts
    let total = 0;
    this.selectedProducts.forEach(item => {
      if (item.properties && item.properties.__type === 'hamper' && item.properties.__price) {
        // Hamper base price (single quantity)
        total += parseFloat(item.properties.__price);
      } else if (item.price) {
        // Product with explicit price property
        total += parseFloat(item.price) * (item.quantity || 1);
      } else if (item.properties && item.properties.__price) {
        // Product with price in properties
        total += parseFloat(item.properties.__price) * (item.quantity || 1);
      }
    });
    this.hamperTotalPrice = total;
    if (this.menuTotalPriceElement) {
      const formattedHamperPrice = this.hamperTotalPrice.toLocaleString('en-GB', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'GBP'});
      this.menuTotalPriceElement.innerText = formattedHamperPrice;
    }
  }

  handleHamperCollectionClick(event){
    if(event.target.classList.contains('button-active')){
      return;
    }
    const collectionId = event.target.dataset.id;
    this.querySelectorAll('.hamper-sub-collection').forEach(el => {
      el.classList.remove('active');
      el.style.display = 'none';
      el.removeEventListener('scrollend', this.handleSubContainerScroll.bind(this));
    });
    const subCollection = this.querySelector(`[data-parent="${collectionId}"]`);
    subCollection.style.display = 'grid';
    subCollection.classList.add('active');
    if(this.hamperScrollTopElement.dataset.firstLoad !== 'true') {
      if (subCollection && subCollection.firstElementChild && window.innerWidth <= 520) {
        this.hamperScrollTopElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    this.hamperScrollTopElement.dataset.firstLoad = 'false';
    this.productButtons.forEach(el => {
      el.classList.remove('button-active');
    });
    event.target.classList.add('button-active');
    this.querySelectorAll('.hamper-sub-collections .button-active').forEach(btn => btn.classList.remove('button-active'));
    this.productGrid.textContent = '';
    this.setupSubCollectionScrollButtons();
    this.selectFirstSubCollection();
  }

  selectFirstSubCollection(){
    this.querySelector('.hamper-sub-collection.active .byo-hamper__sub-collection').click();
    const activeSubCollection = this.querySelector('.hamper-sub-collection.active');
    if(activeSubCollection) {
      activeSubCollection.scrollTo({ left:0, behavior: 'smooth' });
    }
    this.handleSubContainerScroll();
  }

  async handleGetProducts(event) {
    this.loader.classList.toggle('active');
    const handle = event.target.dataset.collectionHandle;
    const pageSize = 250;
    let products = [];
    let hasNextPage = true;
    let endCursor = null;

    this.subCollectionButtons.forEach(el => {
      el.classList.remove('button-active');
    });
    event.target.classList.add('button-active');

    while (hasNextPage) {
      const data = await fetchShopifyCollectionProducts(handle, pageSize, endCursor);
      const productData = data.data.collection.products;
      products = products.concat(productData.nodes);
      hasNextPage = productData.pageInfo.hasNextPage;
      endCursor = productData.pageInfo.endCursor;
    }
    const availableProducts = products
      .filter(product => product.availableForSale);
    const selectedProductMap = new Map(this.selectedProducts.map(item => [item.id, item]));
    if(availableProducts.length) {
      this.productGrid.innerHTML = availableProducts
        .map(product => renderProductCard(product, selectedProductMap))
        .join('');
    }else{
      this.productGrid.innerHTML = `<h4 style="padding-bottom: 50px;">Sorry - no products available in this collection.</h4>`;
    }

    this.loader.classList.toggle('active');

    const productQuantity = this.productGrid.querySelectorAll('.byo-quantity-selector button');
    productQuantity.forEach(button => {
      button.addEventListener('click', this.handleProductQuantityChange.bind(this));
    });
  }

  handleProductQuantityChange(event){
    const variantId = parseInt(event.target.dataset.variantId);
    const quantityElement = document.querySelector(`input[data-variant-id="${variantId}"]`);
    const quantity = parseInt(quantityElement.value);
    let change;
    let newProducts;
    const addPrice = parseFloat(quantityElement.dataset.price);
    if (this.selectedProducts.some(item => item.id === variantId)) {
      if (quantity === 0) {
        newProducts = this.selectedProducts.filter(item => item.id !== variantId);
        this.selectedProducts = newProducts;
      } else {
        newProducts = this.selectedProducts.map(item =>
          item.id === variantId ? { ...item, quantity } : item
        );
        this.selectedProducts = newProducts;
      }
    } else {
      newProducts = [...this.selectedProducts, {
        id: variantId,
        quantity: quantity,
        price: addPrice,
        properties: {
          __hamper: this.menuId
        }
      }];
      this.selectedProducts = newProducts;
    }
    if (event.target.name === 'minus') {
      change = -1;
    } else if (event.target.name === 'plus') {
      change = 1;
    }
    this.updateHamperQuantity();
    event.target.closest('quantity-selector-component').querySelector('button[name=minus]').disabled = quantity === 0;
    if (this.animateAddToCart) {
      this.#animateFlyToDrawer(quantityElement, change);
    }
  }

  hamperValid(){
    const hasMinProducts = this.selectedProducts.length >= 2;
    const hasHamperType = this.selectedProducts.some(
      item => item.properties && item.properties.__type === 'hamper'
    );
    const valid = hasMinProducts && hasHamperType;
    return {
      valid: valid,
      hasMinProducts: hasMinProducts,
      hasHamperType: hasHamperType
    };
  }

  handleAddToCart(){
    const hamperValidation = this.hamperValid();
    if(!hamperValidation.valid){
      let message = '';
      if(!hamperValidation.hasHamperType){
        message += "<li>Select your hamper type.</li>";
      }
      if(!hamperValidation.hasMinProducts){
        message += "<li>Select at least one product.</li>";
      }
      this.dialog.querySelector('.list').innerHTML = message;
      this.dialog.showModal();
      return;
    }
    let formData = {
      'items': this.selectedProducts
    };
    this.selectedProducts = [];
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Accept': 'application/javascript', 'Content-Type': 'application/json'},
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then(() => {
        window.location.href = window.Shopify.routes.root + 'cart';
      });

  }

  get selectedProducts() {
    return this._selectedProducts || [];
  }

  set selectedProducts(val) {
    this._selectedProducts = val;
    this.saveSelectedProductsToStorage();
    this.updateHamperQuantity();
    this.updateHamperTotalPrice();
  }

  saveSelectedProductsToStorage() {
    try {
      localStorage.setItem('dff-hamper', JSON.stringify(this._selectedProducts));
    } catch (e) {
      console.error('Failed to save hamper to localStorage', e);
    }
  }

  loadSelectedProductsFromStorage() {
    let storedProducts = [];
    try {
      const stored = localStorage.getItem('dff-hamper');
      if (stored) {
        storedProducts = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Failed to load hamper from localStorage', e);
    }
    this._selectedProducts = storedProducts;
    // If a hamper is present, select the correct option and button
    const hamper = storedProducts.find(item => item.properties && item.properties.__type === 'hamper');
    if (hamper) {
      // Select the correct option in the hamper variant select
      const select = this.querySelector(`.hamper-variant-picker__select[data-connected-product-id="${hamper.properties.__productId}"]`);
      if (select) {
        const option = Array.from(select.options).find(opt => opt.dataset.variantId == hamper.id);
        if (option) {
          select.value = option.value;
        }
      }
      // Set the correct hamper button to selected
      const hamperBtn = this.querySelector(`.byo-hamper__hamper[data-product-id="${hamper.properties.__productId}"]`);
      if (hamperBtn) {
        this.hamperButtons.forEach(el => {
          el.classList.remove('button-primary');
          el.classList.add('button-secondary');
          el.innerText = 'Select';
        });
        hamperBtn.classList.remove('button-secondary');
        hamperBtn.classList.add('button-primary');
        hamperBtn.innerText = 'Selected';
      }
    }
    this.updateHamperQuantity();
    this.updateHamperTotalPrice();
  }

}

customElements.define('byo-hamper', ByoHamper);
